import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';

@Injectable()
export class PalletApiDataService {
   url = environment.url;

   constructor(private http: HttpClient){}

   //LIST
   public getPalletList(payload: any): Observable<any> {
    return this.http.post(`${this.url}pallet/getStateV2`, payload);
   }

   public getPalletDetailList(payload: string): Observable<any> {
     return this.http.get(`${this.url}/pallet/getCartons/${payload}`)
   }

   //UPDATE 
   public updatePallet(payload: any): Observable<any> {
      return this.http.post(`${this.url}pallet/updateActionV2`, payload);
   }

   //DOWNLOAD
   public downloadReport(payload: any): Observable<any> {
      return this.http.post(`${this.url}pallet/downloadPalletStateV2`, payload);
   }

   public downloadPalletList(payload: any): Observable<any> {
      return this.http.post(`${this.url}pallet/downloadCartons`, payload);
      //return this.http.get(`${this.url}/pallet/downloadCartons/${payload}`)
      //return this.http.post(`${this.url}pallet/downloadCartons/`, payload);
   }

   //GET BOL LIST
   public getBolList(payload: any): Observable<any> {
      return this.http.post(`${this.url}pallet/getCleanupBOLV2`, payload);
   }

   
}